import { useNavigate } from 'react-router-dom';
import { Button, FormCard, Text, VStack } from 'components/ui';
import DownloadApp from 'components/ThankYouView/DownloadApp';
import { useAffiliate } from '../../api/affiliates/useAffiliate';
import { useUserEligibility } from '../../api/user/useUserEligibility';
import { SUBSCRIBED_HOME_PATH } from '../../utils/subscribedHome';
import { AccountPage } from './AccountPage';
import { useAccountUser } from './useAccountUser';
import { LoadingScreen } from '../ui/LoadingScreen';

export const AccountHome = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAccountUser();
  const { eligibility, isError: planError } = useUserEligibility();
  const { affiliate: planAffiliate } = useAffiliate({
    affiliateId: eligibility?.affiliate,
  });

  if (isLoading || !user) return <LoadingScreen />;

  const name = [user.first_name, user.last_name].filter(Boolean).join(' ');
  const showHealthPlan = !!eligibility || planError;
  const planName = eligibility ? planAffiliate?.name?.trim() : '';
  const healthPlanLabel = !eligibility
    ? "We couldn't load your health plan."
    : planName || 'Health plan on file.';

  return (
    <AccountPage
      testID="account-home"
      title={
        user.first_name ? `Welcome back, ${user.first_name}` : 'Welcome back'
      }
    >
      <FormCard>
        <Text textStyle="label.section">Profile</Text>
        {name && <Text>{name}</Text>}
        <Text color="blueGray.600">{user.email}</Text>
        <Button
          data-testid="account-update-profile"
          onClick={() => navigate(`${SUBSCRIBED_HOME_PATH}/profile`)}
          variant="outline"
          w="100%"
        >
          Update profile
        </Button>
      </FormCard>

      {showHealthPlan && (
        <FormCard>
          <Text textStyle="label.section">Health plan</Text>
          <Text color={planName ? undefined : 'blueGray.600'}>
            {healthPlanLabel}
          </Text>
          <Button
            data-testid="account-update-health-plan"
            onClick={() => navigate(`${SUBSCRIBED_HOME_PATH}/health-plan`)}
            variant="outline"
            w="100%"
          >
            Update health plan
          </Button>
        </FormCard>
      )}

      <FormCard>
        <VStack align="stretch" gap={3}>
          <Text textStyle="label.section">Get the app</Text>
          <DownloadApp />
        </VStack>
      </FormCard>
    </AccountPage>
  );
};
